<div
  class="sp-row__align"
  style="height: 24px">
  <mat-icon
    (click)="onCopyClick(); $event.stopPropagation()"
    color="accent"
    style="margin-left: -8px"
    class="sp-icon__s sp-cursor__pointer"
    [matTooltip]="'GENERAL.COPY_CTA' | translate">
    content_copy
  </mat-icon>
  <p
    [ngClass]="content_class"
    (click)="content_click.emit()">
    {{ is_shrinked_id ? getShrinkedID() : (content || '-' | translate) }}
  </p>
</div>
